// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"daa88e97","459":"ddf30afc","494":"fed5a9c1","618":"eb6dcca8"}[chunkId] + ".chunk.css";
};